import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles(({ colors, palette }: Theme) => createStyles({
  filterLine: {
    width: '100%',
    display: 'flex',
  },
  tagsLine: {
    marginLeft: 10,
    paddingBottom: 4,
    display: 'flex',
    whiteSpace: 'nowrap',
    overflowX: 'auto',

    '&::-webkit-scrollbar': {
      width: '0.4em',
      height: 5,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.28)',
      borderRadius: 5,
    },
  },

  tag: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #01B3C5',
    borderRadius: 16,
    fontWeight: 300,
    userSelect: 'none',
    fontSize: 12,
    padding: '2px 2px 2px 5px',

    '& + div': {
      marginLeft: 3,
    },
  },
  tagButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 16,
    height: 16,
    background: '#01B3C5',
    borderRadius: '50%',
    marginLeft: 4,
    padding: 0,
    cursor: 'pointer',
  },
  tagIcon: {
    width: 14,
    height: 14,
    color: '#FFFFFF',
  },
}));

export default useStyles;
